var CONFIG = [

  // *** CHAIN LINK FENCE PARTS LIST ***
  
  {
    "Name": "36-residential-galvanized-chain-link",
    "Fabric": "5115031GBW",
    "EndCornerPost": "4065060",
    "LinePost": "4045060",
    "TopRail": "4035210S",
    "EndPostCap": "10106",
    "LinePostCap": "10104",
    "LineTop": "10201",
    "TensionBand": "10406",
    "EndBand": "10456",
    "Sleeve": "10501",
    "RailEnds": "10703",
    "MaleHinge": "10816",
    "FemaleHinge": "10803",
    "ForkLatch": "10886",
    "ForkLatchHanger": "10873",
    "DropRod": "10922",
    "WireTires": "11130",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "CarriageBoltLatchHanger": "11170",
    "CarriageBoltMaleHinge": "11175",
    "CarriageBoltFemaleHinge": "11173",
    "SingleSwingGate": "28388899225694",
    "DoubleSwingGate": "41805393952841",
    "DoubleSwingGateForkLatchHanger":"10873",
    "DoubleSwingGateForkLatch":"10883",
    "DoubleSwingGate2ExtraFemaleHinges":"10803",
    "TensionBar":"11001",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },
  {
    "Name": "42-residential-galvanized-chain-link",
    "Fabric": "5115421GBW",
    "EndCornerPost": "4065060",
    "LinePost": "4045060",
    "TopRail": "4035210S",
    "EndPostCap": "10106",
    "LinePostCap": "10104",
    "LineTop": "10201",
    "TensionBand": "10406",
    "EndBand": "10456",
    "Sleeve": "10501",
    "RailEnds": "10703",
    "MaleHinge": "10816",
    "FemaleHinge": "10803",
    "ForkLatch": "10886",
    "ForkLatchHanger": "10873",
    "DropRod": "10922",
    "WireTires": "11130",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "CarriageBoltLatchHanger": "11170",
    "CarriageBoltMaleHinge": "11175",
    "CarriageBoltFemaleHinge": "11173",
    "SingleSwingGate": "6973900161052",
    "DoubleSwingGate": "28388887724126",
    "DoubleSwingGateForkLatchHanger":"10873",
    "DoubleSwingGateForkLatch":"10883",
    "DoubleSwingGate2ExtraFemaleHinges":"10803",
    "TensionBar":"11002",
    "ImageUrl": "{{'Chainlink-galvanized-42.png' | asset_url }}"
  },  
  {
    "Name": "42-residential-black-chain-link",
    "Color": "Black",
    "Fabric": "5090421VB",
    "EndCornerPost": "4065060VB",
    "LinePost": "4045060VB",
    "TopRail": "4035210SVB",
    "EndPostCap": "10106B",
    "LinePostCap": "10104B",
    "LineTop": "10201B",
    "TensionBand": "10406B",
    "EndBand": "10456B",
    "Sleeve": "10501B",
    "RailEnds": "10703B",
    "MaleHinge": "10816B",
    "FemaleHinge": "10803B",
    "ForkLatch": "10886B",
    "ForkLatchHanger": "10873B",
    "DropRod": "10922B",
    "WireTires": "11130B",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "CarriageBoltMaleHinge": "11174B",
    "CarriageBoltFemaleHinge": "11174B",
    "SingleSwingGate": "41805032587337",
    "DoubleSwingGate": "41805010239561",
    "DoubleSwingGateForkLatchHanger":"10873B",
    "DoubleSwingGateForkLatch":"10883B",
    "DoubleSwingGate2ExtraFemaleHinges":"10803B",
    "TensionBar":"11003B",
    "ImageUrl": "{{'Chainlink-Vinyl-coated-42.png' | asset_url }}"
  },  
  {
    "Name": "48-residential-galvanized-chain-link",
    "Fabric": "5115041GBW",
    "EndCornerPost": "4065060",
    "LinePost": "4045060",
    "TopRail": "4035210S",
    "EndPostCap": "10106",
    "LinePostCap": "10104",
    "LineTop": "10201",
    "TensionBand": "10406",
    "EndBand": "10456",
    "Sleeve": "10501",
    "RailEnds": "10703",
    "MaleHinge": "10816",
    "FemaleHinge": "10803",
    "ForkLatch": "10886",
    "ForkLatchHanger": "10873",
    "DropRod": "10922",
    "WireTires": "11130",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "CarriageBoltLatchHanger": "11170",
    "CarriageBoltMaleHinge": "11175",
    "CarriageBoltFemaleHinge": "11173",
    "SingleSwingGate": "6973900292124",
    "DoubleSwingGate": "28388888150110",
    "DoubleSwingGateForkLatchHanger":"10873",
    "DoubleSwingGateForkLatch":"10883",
    "DoubleSwingGate2ExtraFemaleHinges":"10803",
    "TensionBar":"11003",
    "ImageUrl": "{{'Chainlink-galvanized-48.png' | asset_url }}"
  },
  {
    "Name": "48-residential-black-chain-link",
    "Color": "Black",
    "Fabric": "5090041VB",
    "EndCornerPost": "4065060VB",
    "LinePost": "4045060VB",
    "TopRail": "4035210SVB",
    "EndPostCap": "10106B",
    "LinePostCap": "10104B",
    "LineTop": "10201B",
    "TensionBand": "10406B",
    "EndBand": "10456B",
    "Sleeve": "10501B",
    "RailEnds": "10703B",
    "MaleHinge": "10816B",
    "FemaleHinge": "10803B",
    "ForkLatch": "10886B",
    "ForkLatchHanger": "10873B",
    "DropRod": "10922B",
    "WireTires": "11130B",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "CarriageBoltMaleHinge": "11174B",
    "CarriageBoltFemaleHinge": "11174B",
    "SingleSwingGate": "6998067904540",
    "DoubleSwingGate": "41805010239561",
    "DoubleSwingGateForkLatchHanger":"10873B",
    "DoubleSwingGateForkLatch":"10883B",
    "DoubleSwingGate2ExtraFemaleHinges":"10803B",
    "TensionBar":"11003B",
    "ImageUrl": "{{'Chainlink-Vinyl-coated-48.png' | asset_url }}"
  },
  {
    "Name": "48-light-commercial-galvanized-chain-link",
    "Fabric": "5090041",
    "EndCornerPost": "4065060",
    "LinePost": "4055060",
    "TopRail": "4045210S", 
    "TensionBar": "11003",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10126",
    "TensionBand": "10406",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10456",
    "WireTires": "11138",
    "BullDogHinge": "10835",    
    "CommercialForkLatch": "10888",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "48-light-commercial-black-chain-link",
    "Fabric": "5080041VB",
    "EndCornerPost": "4065060VB",
    "LinePost": "4055080VB",
    "TopRail": "4045210VB", 
    "TensionBar": "11003B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10106B",
    "TensionBand": "10406B",
    "LineTop": "10214B",
    "RailEnds": "10709B",
    "EndBand": "10456B",
    "WireTires": "11132B",
    "BullDogHinge": "10835B",    
    "ForkLatch": "10886B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "48-medium-commercial-galvanized-chain-link",
    "Fabric": "5090041",
    "EndCornerPost": "4079240CFT6",
    "LinePost": "4056080",
    "TopRail": "4046210S", 
    "TensionBar": "11003",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },      
  {
    "Name": "48-medium-commercial-black-chain-link",
    "Fabric": "5080041VB",
    "EndCornerPost": "4079240VBCFT6",
    "LinePost": "4056080VB",
    "TopRail": "4046210VB", 
    "TensionBar": "11003B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "LineTop": "10214B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "48-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090041",
    "EndCornerPost": "4068000CFT6",
    "LinePost": "4058000CFT6",
    "TopRail": "4048000",
    "RailSleeve": "10502",
    "TensionBar": "11003",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10126",
    "TensionBand": "10406",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10456",
    "WireTires": "11138",
    "BullDogHinge": "10835",    
    "CommercialForkLatch": "10888",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "48-heavy-commercial-black-chain-link",
    "Fabric": "5080041VB",
    "EndCornerPost": "4078240VBCFT6",
    "LinePost": "4058000VBCFT6",
    "TopRail": "4048000VB", 
    "RailSleeve": "10502B",    
    "TensionBar": "11003B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "LineTop": "10214B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "60-residential-galvanized-chain-link",
    "Fabric": "5115051GBW",
    "EndCornerPost": "4065080",
    "LinePost": "4045070",
    "TopRail": "4035210S",
    "EndPostCap": "10106",
    "LinePostCap": "10104",
    "LineTop": "10201",
    "TensionBand": "10406",
    "EndBand": "10456",
    "Sleeve": "10501",
    "RailEnds": "10703",
    "MaleHinge": "10816",
    "FemaleHinge": "10803",
    "ForkLatch": "10886",
    "ForkLatchHanger": "10873",
    "DropRod": "10922",
    "WireTires": "11130",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "CarriageBoltLatchHanger": "11170",
    "CarriageBoltMaleHinge": "11175",
    "CarriageBoltFemaleHinge": "11173",
    "SingleSwingGate": "6973900455964",
    "DoubleSwingGate": "28388888150110",
    "DoubleSwingGateForkLatchHanger":"10873",
    "DoubleSwingGateForkLatch":"10883",
    "DoubleSwingGate2ExtraFemaleHinges":"10803",
    "TensionBar":"11004",
    "ImageUrl": "{{'Chainlink-galvanized-60.png' | asset_url }}"
  },
  {
    "Name": "60-residential-black-chain-link",
    "Color": "Black",
    "Fabric": "5090051VB",
    "EndCornerPost": "4065080VB",
    "LinePost": "4045080VB",
    "TopRail": "4035210SVB",
    "EndPostCap": "10106B",
    "LinePostCap": "10104B",
    "LineTop": "10201B",
    "TensionBand": "10406B",
    "EndBand": "10456B",
    "Sleeve": "10501B",
    "RailEnds": "10703B",
    "MaleHinge": "10816B",
    "FemaleHinge": "10803B",
    "ForkLatch": "10886B",
    "ForkLatchHanger": "10873B",
    "DropRod": "10922B",
    "WireTires": "11130B",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "CarriageBoltMaleHinge": "11174B",
    "CarriageBoltFemaleHinge": "11174B",
    "SingleSwingGate": "6998067937308",
    "DoubleSwingGate": "28388882677854",
    "DoubleSwingGateForkLatchHanger":"10873B",
    "DoubleSwingGateForkLatch":"10883B",
    "DoubleSwingGate2ExtraFemaleHinges":"10803B",
    "TensionBar":"11004B",
    "ImageUrl": "{{'Chainlink-Vinyl-coated-60.png' | asset_url }}"
  },
  {
    "Name": "60-light-commercial-galvanized-chain-link",
    "Fabric": "5090051",
    "EndCornerPost": "4065080",
    "LinePost": "4055080",
    "TopRail": "4045210S", 
    "TensionBar": "11004",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10126",
    "TensionBand": "10406",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10456",
    "WireTires": "11138",
    "BullDogHinge": "10835",    
    "CommercialForkLatch": "10888",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "60-medium-commercial-galvanized-chain-link",
    "Fabric": "5090051",
    "EndCornerPost": "4076099",
    "LinePost": "4056080",
    "TopRail": "4046210S", 
    "TensionBar": "11004",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "60-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090051",
    "EndCornerPost": "4068000CFT8",
    "LinePost": "4058000CFT8",
    "TopRail": "4048000",
    "RailSleeve": "10502",
    "TensionBar": "11004",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10126",
    "TensionBand": "10406",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10456",
    "WireTires": "11138",
    "BullDogHinge": "10835",    
    "CommercialForkLatch": "10888",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "72-residential-galvanized-chain-link",
    "Fabric": "5115061GBW",
    "EndCornerPost": "4065080",
    "LinePost": "4045080",
    "TopRail": "4035210S",
    "EndPostCap": "10106",
    "LinePostCap": "10104",
    "LineTop": "10201",
    "TensionBand": "10406",
    "EndBand": "10456",
    "Sleeve": "10501",
    "RailEnds": "10703",
    "MaleHinge": "10816",
    "FemaleHinge": "10803",
    "ForkLatch": "10886",
    "ForkLatchHanger": "10873",
    "DropRod": "10922",
    "WireTires": "11130",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "CarriageBoltLatchHanger": "11170",
    "CarriageBoltMaleHinge": "11175",
    "CarriageBoltFemaleHinge": "11173",
    "SingleSwingGate": "6973900587036",
    "DoubleSwingGate": "28388890116190",
    "DoubleSwingGateForkLatchHanger":"10873",
    "DoubleSwingGateForkLatch":"10883",
    "DoubleSwingGate2ExtraFemaleHinges":"10803",
    "TensionBar":"11015",
    "ImageUrl": "{{'Chainlink-galvanized-72.png' | asset_url }}"
  },
  {
    "Name": "72-residential-black-chain-link",
    "Color": "Black",
    "Fabric": "5090061VB",
    "EndCornerPost": "4065080VB",
    "LinePost": "4045080VB",
    "TopRail": "4035210SVB",
    "EndPostCap": "10106B",
    "LinePostCap": "10104B",
    "LineTop": "10201B",
    "TensionBand": "10406B",
    "EndBand": "10456B",
    "Sleeve": "10501B",
    "RailEnds": "10703B",
    "MaleHinge": "10816B",
    "FemaleHinge": "10803B",
    "ForkLatch": "10886B",
    "ForkLatchHanger": "10873B",
    "DropRod": "10922B",
    "WireTires": "11130B",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "CarriageBoltMaleHinge": "11174B",
    "CarriageBoltFemaleHinge": "11174B",
    "SingleSwingGate": "6998067937308",
    "DoubleSwingGate": "28388882677854",
    "DoubleSwingGateForkLatchHanger":"10873B",
    "DoubleSwingGateForkLatch":"10883B",
    "DoubleSwingGate2ExtraFemaleHinges":"10803B",
    "TensionBar":"11004B",
    "ImageUrl": "{{'Chainlink-Vinyl-coated-60.png' | asset_url }}"
  },  
  {
    "Name": "72-light-commercial-galvanized-chain-link",
    "Fabric": "5090061",
    "EndCornerPost": "4065080",
    "LinePost": "4055080",
    "TopRail": "4045210S", 
    "TensionBar": "11015",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10126",
    "TensionBand": "10406",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10456",
    "WireTires": "11138",
    "BullDogHinge": "10835",    
    "MaleHinge": "10816",
    "FemaleHinge": "10803",
    "CommercialForkLatch": "10888",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "72-light-commercial-black-chain-link",
    "Fabric": "5080061VB",
    "EndCornerPost": "4065080VB",
    "LinePost": "4055080VB",
    "TopRail": "4045210VB", 
    "TensionBar": "11015B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10106B",
    "TensionBand": "10406B",
    "LineTop": "10214B",
    "RailEnds": "10709B",
    "EndBand": "10456B",
    "WireTires": "11132B",
    "BullDogHinge": "10835B",    
    "ForkLatch": "10886B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },     
  {
    "Name": "72-medium-commercial-galvanized-chain-link",
    "Fabric": "5090061",
    "EndCornerPost": "4076099",
    "LinePost": "4059086",
    "TopRail": "4046210S", 
    "TensionBar": "11015",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "72-medium-commercial-galvanized-chain-link-barbwire",
    "Fabric": "5090061",
    "EndCornerPost": "4076090CFT10",
    "LinePost": "4059086",
    "TopRail": "4046210S", 
    "TensionBar": "11015",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "BarbwireArm": "10307",
    "BarbwireRoll": "20072",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },    
  {
    "Name": "72-medium-commercial-black-chain-link",
    "Fabric": "5080061VB",
    "EndCornerPost": "4076106VB",
    "LinePost": "4056080VB",
    "TopRail": "4046210VB", 
    "TensionBar": "11015B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "LineTop": "10214B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },      
  {
    "Name": "72-medium-commercial-black-chain-link-barbwire",
    "Fabric": "5080061VB",
    "EndCornerPost": "4076106VB",
    "LinePost": "4056080VB",
    "TopRail": "4046210VB", 
    "TensionBar": "11015B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "BarbwireArm": "10307B",
    "BarbwireRoll": "20072B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },    
  {
    "Name": "72-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090061",
    "EndCornerPost": "4078090",
    "LinePost": "4058000CFT8",
    "TopRail": "4048000",
    "RailSleeve": "10502",
    "TensionBar": "11015",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10214",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "72-heavy-commercial-galvanized-chain-link-barbwire",
    "Fabric": "5090061",
    "EndCornerPost": "4078106",
    "LinePost": "4058000CFT8",
    "TopRail": "4048000",
    "RailSleeve": "10502",
    "TensionBar": "11015",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "BarbwireArm": "10307",
    "BarbwireRoll": "20072",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "72-heavy-commercial-black-chain-link",
    "Fabric": "5080061VB",
    "EndCornerPost": "4078106VB",
    "LinePost": "4058000VBCFT8",
    "TopRail": "4048000VB", 
    "RailSleeve": "10502B",
    "TensionBar": "11015B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "LineTop": "10214B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },     
  {
    "Name": "72-heavy-commercial-black-chain-link-barbwire",
    "Fabric": "5080061VB",
    "EndCornerPost": "4078106VB",
    "LinePost": "4058000VBCFT8",
    "TopRail": "4048000VB", 
    "RailSleeve": "10502B",
    "TensionBar": "11015B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "BarbwireArm": "10307B",
    "BarbwireRoll": "20072B",    
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },     
  {
    "Name": "84-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090072",
    "EndCornerPost": "4078106",
    "LinePost": "4068096",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11016",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10215",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "84-heavy-commercial-galvanized-chain-link-barbwire",
    "Fabric": "5090072",
    "EndCornerPost": "4078130",
    "LinePost": "4068096",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11016",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "BarbwireArm": "10309",
    "BarbwireRoll": "20072",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "96-medium-commercial-black-chain-link",
    "Fabric": "50800962B",
    "EndCornerPost": "4076130VB",
    "LinePost": "4069106VB",
    "TopRail": "4046210VB", 
    "TensionBar": "11017B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "LineTop": "10215B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },       
  {
    "Name": "96-medium-commercial-black-chain-link-barbwire",
    "Fabric": "50800962B",
    "EndCornerPost": "4076130VB",
    "LinePost": "4069106VB",
    "TopRail": "4046210VB", 
    "TensionBar": "11017B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "BarbwireArm": "10309B",
    "BarbwireRoll": "20072B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },      
  {
    "Name": "96-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090082",
    "EndCornerPost": "4078130",
    "LinePost": "4068106",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11017",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10215",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "96-heavy-commercial-galvanized-chain-link-barbwire",
    "Fabric": "5090082",
    "EndCornerPost": "4078130",
    "LinePost": "4068106",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11017",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "BarbwireArm": "10309",
    "BarbwireRoll": "20072",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "96-heavy-commercial-black-chain-link",
    "Fabric": "50800962B",
    "EndCornerPost": "4078240VBCFT13",
    "LinePost": "4068106VB",
    "TopRail": "4048000VB", 
    "RailSleeve": "10502B",    
    "TensionBar": "11017B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "LineTop": "10215B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },        
  {
    "Name": "96-heavy-commercial-black-chain-link-barbwire",
    "Fabric": "50800962B",
    "EndCornerPost": "4078240VBCFT13",
    "LinePost": "4068106VB",
    "TopRail": "4048000VB", 
    "RailSleeve": "10502B",    
    "TensionBar": "11017B",    
    "TensionWire": "20081VB",
    "HogRings": "11143B",
    "EndPostCap": "10127B",
    "TensionBand": "10417B",
    "BarbwireArm": "10309B",
    "BarbwireRoll": "20072B",
    "RailEnds": "10709B",
    "EndBand": "10467B",
    "WireTires": "11132B",
    "BullDogHinge": "10833B",    
    "ForkLatch": "10889B",
    "ForkLatchHanger": "10874B",  
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170B",
    "CarriageBoltTensionBand": "11170B",
    "CarriageBoltLatchHanger": "11170B",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },    
  {
    "Name": "120-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090101",
    "EndCornerPost": "4078130",
    "LinePost": "4068126",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11017",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10215",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "120-heavy-commercial-galvanized-chain-link-barbwire",
    "Fabric": "5090101",
    "EndCornerPost": "4078000CFT14",
    "LinePost": "4068126",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11017",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "BarbwireArm": "10309",
    "BarbwireRoll": "20072",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  {
    "Name": "144-heavy-commercial-galvanized-chain-link",
    "Fabric": "5090121",
    "EndCornerPost": "4078000CFT146",
    "LinePost": "4068000CFT14",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11017",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "LineTop": "10215",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },   
  {
    "Name": "144-heavy-commercial-galvanized-chain-link-barbwire",
    "Fabric": "5090121",
    "EndCornerPost": "4078000CFT16",
    "LinePost": "4068000CFT14",
    "TopRail": "4048000", 
    "RailSleeve": "10502",    
    "TensionBar": "11017",    
    "TensionWire": "20081",
    "HogRings": "11143",
    "EndPostCap": "10127",
    "TensionBand": "10417",
    "BarbwireArm": "10309",
    "BarbwireRoll": "20072",
    "RailEnds": "10709",
    "EndBand": "10467",
    "WireTires": "11138",
    "BullDogHinge": "10833",    
    "CommercialForkLatch": "10891",
    "DropRod": "10923",
    "CarriageBoltEndBand": "11170",
    "CarriageBoltTensionBand": "11170",
    "ImageUrl": "{{'Chainlink-galvanized-36.png' | asset_url }}"
  },  
  
  // *** Ornamental Fence Parts List ***

  {
    "Name": "4-flat-top-ornamental-iron",
    "Panel": "8AF4X94FT",
    "EndCornerPost": "8W12P69",
    "EndCornerCap": "8AB506",
    "MaleHinge": "8HB403",
    "FemaleHinge": "8HB404",
    "LatchHanger": "8HB301",
    "ForkLatch": "8HB411",
    "FlatMountBracket": "8BFUNIVER",
    "GatePost": "8W125P96",
    "GatePostCap": "8AB507",
    "SingleSwingGate": "8GATE4X4M",
    "DoubleSwingGate": "8GATE4X4MD",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"8HB301",
    "DoubleSwingGateForkLatch":"8HB401",
    "DoubleSwingGateDropRod":"8HB316",
    "DoubleGateExtraFemaleHingeSet":"8HB404",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Steel-Flat-top-4.png' | asset_url }}"
  },
  {
    "Name": "5-flat-top-ornamental-iron",
    "Panel": "8AF5X94FT",
    "EndCornerPost": "8W12P81",
    "EndCornerCap": "8AB506",
    "MaleHinge": "8HB413",
    "FemaleHinge": "8HB404",
    "LatchHanger": "8HB301",
    "ForkLatch": "8HB411",
    "FlatMountBracket": "8BFUNIVER",
    "GatePost": "8W125P96",
    "GatePostCap": "8AB507",
    "SingleSwingGate": "8GATE4X5M",
    "DoubleSwingGate": "8GATE4X5MD",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"8HB301",
    "DoubleSwingGateForkLatch":"8HB401",
    "DoubleSwingGateDropRod":"8HB316",
    "DoubleGateExtraFemaleHingeSet":"8HB404",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Steel-Flat-top-5.png' | asset_url }}"
  },
  {
    "Name": "5-spear-top-ornamental-iron",
    "Panel": "8AF5X94ST",
    "EndCornerPost": "8W12P81",
    "EndCornerCap": "8AB506",
    "MaleHinge": "8HB413",
    "FemaleHinge": "8HB404",
    "LatchHanger": "8HB301",
    "ForkLatch": "8HB411",
    "FlatMountBracket": "8BFUNIVER",
    "GatePost": "8W125P96",
    "GatePostCap": "8AB507",
    "SingleSwingGate": "8GATE4X5C",
    "DoubleSwingGate": "8GATE4X5CD",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"8HB301",
    "DoubleSwingGateForkLatch":"8HB401",
    "DoubleSwingGateDropRod":"8HB316",
    "DoubleGateExtraFemaleHingeSet":"8HB404",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Steel-spear-top-5.png' | asset_url }}"    
  },
  {
    "Name": "6-flat-top-ornamental-iron",
    "Panel": "8AF6X94FT",
    "EndCornerPost": "8W12P93", 
    "EndCornerCap": "8AB506",
    "MaleHinge": "8HB413",
    "FemaleHinge": "8HB404",
    "LatchHanger": "8HB301",
    "ForkLatch": "8HB411",
    "FlatMountBracket": "8BFUNIVER",
    "GatePost": "8W125P96",
    "GatePostCap": "8AB507",
    "SingleSwingGate": "8GATE4X6M",
    "DoubleSwingGate": "8GATE4X6MD",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"8HB301",
    "DoubleSwingGateForkLatch":"8HB401",
    "DoubleSwingGateDropRod":"8HB316",
    "DoubleGateExtraFemaleHingeSet":"8HB404",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Steel-Flat-top-6.png' | asset_url }}"
  },
  {
    "Name": "6-spear-top-ornamental-iron",
    "Panel": "8AF6X94ST",
    "EndCornerPost": "8W12P93",
    "EndCornerCap": "8AB506",
    "MaleHinge": "8HB413",
    "FemaleHinge": "8HB404",
    "LatchHanger": "8HB301",
    "ForkLatch": "8HB411",
    "FlatMountBracket": "8BFUNIVER",
    "GatePost": "8W125P96",
    "GatePostCap": "8AB507",
    "SingleSwingGate": "8GATE4X6C",
    "DoubleSwingGate": "8GATE4X6CD",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"8HB301",
    "DoubleSwingGateForkLatch":"8HB401",
    "DoubleSwingGateDropRod":"8HB316",
    "DoubleGateExtraFemaleHingeSet":"8HB404",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Steel-spear-top-6.png' | asset_url }}"
  },
    {
    "Name": "6-aluminum-flat-top-ornamental",
    "Panel": "AFS-SA-3CHST72",
    "EndCornerPost": "31223519117406",
    "EndCornerCap": "AFS-PC-2",
    "MaleHinge": "",
    "FemaleHinge": "",
    "LatchHanger": "",
    "ForkLatch": "10906",
    "FlatMountBracket": "",
    "GatePost": "AFS-ALP-94-2.5-075", 
    "GatePostCap": "AFS-PC-25", 
    "SingleSwingGate": "31289598902366",
    "DoubleSwingGate": "16118124249182",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"",
    "DoubleSwingGateForkLatch":"",
    "DoubleSwingGateDropRod":"",
    "DoubleGateExtraFemaleHingeSet":"",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Aluminum-Flat-top-6.png' | asset_url }}"
  },
  {
    "Name": "5-aluminum-flat-top-ornamental",
    "Panel": "AFS-SA-3CHST60",
    "EndCornerPost": "AFS-ALP-82-2-125",
    "EndCornerCap": "AFS-PC-2",
    "MaleHinge": "",
    "FemaleHinge": "",
    "LatchHanger": "",
    "ForkLatch": "10906",
    "FlatMountBracket": "",
    "GatePost": "AFS-ALP-82-2.5-125",
    "GatePostCap": "AFS-PC-25",
    "SingleSwingGate": "31289562431582",
    "DoubleSwingGate": "16118123987038",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"",
    "DoubleSwingGateForkLatch":"",
    "DoubleSwingGateDropRod":"",
    "DoubleGateExtraFemaleHingeSet":"",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Aluminum-Flat-top-5.png' | asset_url }}"
  },
  {
    "Name": "4-aluminum-flat-top-ornamental",
    "Panel": "AFS-SA-3CHST48",
    "EndCornerPost": "AFS-ALP-70-2-062",
    "EndCornerCap": "AFS-PC-2",
    "MaleHinge": "",
    "FemaleHinge": "",
    "LatchHanger": "",
    "ForkLatch": "10906",
    "FlatMountBracket": "",
    "GatePost": "AFS-ALP-70-2.5-075",
    "GatePostCap": "AFS-PC-25",
    "SingleSwingGate": "31289348423774",
    "DoubleSwingGate": "16118123462750",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"",
    "DoubleSwingGateForkLatch":"",
    "DoubleSwingGateDropRod":"",
    "DoubleGateExtraFemaleHingeSet":"",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Aluminum-Flat-top-4.png' | asset_url }}"
  },
  {
    "Name": "6-aluminum-spear-top-ornamental",
    "Panel": "31280789422174",
    "EndCornerPost": "31223519117406",
    "EndCornerCap": "AFS-PC-2",
    "MaleHinge": "",
    "FemaleHinge": "",
    "LatchHanger": "",
    "ForkLatch": "10906",
    "FlatMountBracket": "",
    "GatePost": "AFS-ALP-94-2.5-075",
    "GatePostCap": "AFS-PC-25",
    "SingleSwingGate": "31280798466142",
    "DoubleSwingGate": "16153249087582",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"",
    "DoubleSwingGateForkLatch":"",
    "DoubleSwingGateDropRod":"",
    "DoubleGateExtraFemaleHingeSet":"",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Aluminum-spear-top-6.png' | asset_url }}"
  },
  {
    "Name": "5-aluminum-spear-top-ornamental",
    "Panel": "31264815939678",
    "EndCornerPost": "AFS-ALP-82-2-125",
    "EndCornerCap": "AFS-PC-2",
    "MaleHinge": "",
    "FemaleHinge": "",
    "LatchHanger": "",
    "ForkLatch": "10906",
    "FlatMountBracket": "",
    "GatePost": "AFS-ALP-82-2.5-125",
    "GatePostCap": "AFS-PC-25",
    "SingleSwingGate": "31280793419870",
    "DoubleSwingGate": "16153248825438",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"",
    "DoubleSwingGateForkLatch":"",
    "DoubleSwingGateDropRod":"",
    "DoubleGateExtraFemaleHingeSet":"",
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Aluminum-spear-top-5.png' | asset_url }}"
  },
  {
    "Name": "4-aluminum-spear-top-ornamental",
    "Panel": "31264766689374",
    "EndCornerPost": "AFS-ALP-70-2-062",
    "EndCornerCap": "AFS-PC-2",
    "MaleHinge": "",
    "FemaleHinge": "",
    "LatchHanger": "",
    "ForkLatch": "10906",
    "FlatMountBracket": "",
    "GatePost": "AFS-ALP-70-2.5-075",
    "GatePostCap": "AFS-PC-25",
    "SingleSwingGate": "31264774815838",
    "DoubleSwingGate": "16153248301150",
    "BracketMultiply": 6,
    "DoubleSwingGateLatchHanger":"",
    "DoubleSwingGateForkLatch":"",
    "DoubleSwingGateDropRod":"",
    "DoubleGateExtraFemaleHingeSet":"", 
    "oc" : "94",
    "ImageUrl": "{{'Ornamental-Aluminum-spear-top-4.png' | asset_url }}"
  },

  // *** Vinyl Fence Parts List *** 

  {
    "Name": "6-vinyl-privacy-fence-afc-373-white",
    "Color": "White",
    "Panel": "AFC373-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC373E",
    "LinePost": "7WAFC373L",
    "CornerPost": "7WAFC373C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "6-vinyl-privacy-fence-afc-373-tan",
    "Color": "Tan",
    "Panel": "AFC373-TAN",   
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC373E",     
    "LinePost": "7TAFC373L",
    "CornerPost": "7TAFC373C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-khaki.png' | asset_url }}"
  },
  {
    "Name": "6-vinyl-privacy-fence-afc-373-adobe",
    "Color": "Adobe",
    "Panel": "AFC373-ADOBE",
    "BlankPost": "7F10CD096081",
    "EndPost": "7DAFC373E",        
    "LinePost": "7DAFC373L",
    "CornerPost": "7DAFC373C",
    "Cap": "7C55PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
    {
    "Name": "6-vinyl-privacy-fence-afc-373-light-gray",
    "Color": "Light Gray",
    "Panel": "AFC373-LIGHTGRAY",
    "BlankPost": "7F10CL096081",
    "EndPost": "7LAFC373E",        
    "LinePost": "7LAFC373L",
    "CornerPost": "7LAFC373C",
    "Cap": "7C55PYRA-HWL",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
      {
    "Name": "6-vinyl-privacy-fence-afc-373-dark-gray",
    "Color": "Dark Gray",
    "Panel": "AFC373-DARKGRAY",
    "BlankPost": "7F10CF096081",
    "EndPost": "7FAFC373E",        
    "LinePost": "7FAFC373L",
    "CornerPost": "7FAFC373C",
    "Cap": "7C55PYRA-HWF",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
      {
    "Name": "6-vinyl-privacy-fence-afc-373-mocha-walnut",
    "Color": "Mocha Walnut",
    "Panel": "AFC373-MOCHAWALNUT",
    "BlankPost": "7F10CO096081",
    "EndPost": "7OAFC373E",        
    "LinePost": "7OAFC373L",
    "CornerPost": "7OAFC373C",
    "Cap": "7C55PYRA-HWO",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
      {
    "Name": "6-vinyl-privacy-fence-afc-373-green-teak",
    "Color": "Green Teak",
    "Panel": "AFC373-GREENTEAK",
    "BlankPost": "7F10CU096081",
    "EndPost": "7UAFC373E",        
    "LinePost": "7UAFC373L",
    "CornerPost": "7UAFC373C",
    "Cap": "7C55PYRA-HWU",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
      {
    "Name": "6-vinyl-privacy-fence-afc-373-chai-gray",
    "Color": "Chai Gray",
    "Panel": "AFC373-CHAIGRAY",
    "BlankPost": "7F10CI096081",
    "EndPost": "7IAFC373E",        
    "LinePost": "7IAFC373L",
    "CornerPost": "7IAFC373C",
    "Cap": "7C55PYRA-HWI",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
      {
    "Name": "6-vinyl-privacy-fence-afc-373-aspen-latte",
    "Color": "Aspen Latte",
    "Panel": "AFC373-ASPENLATTE",
    "BlankPost": "7F10CA096081",
    "EndPost": "7AAFC373E",        
    "LinePost": "7AAFC373L",
    "CornerPost": "7AAFC373C",
    "Cap": "7C55PYRA-HWA",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-6-Sandstone.png' | asset_url }}"
  },
   {
    "Name": "6-vinyl-privacy-fence-w-picket-accent-afc-018-white",
    "Color": "White",
    "Panel": "AFC018-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC018E",
    "LinePost": "7WAFC018L",
    "CornerPost": "7WAFC018C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-wa-k-31-white.png' | asset_url }}"
    }, 
     {
    "Name": "6-vinyl-privacy-fence-w-picket-accent-afc-018-tan",
    "Color": "Tan",
    "Panel": "AFC018-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC018E",
    "LinePost": "7TAFC018L",
    "CornerPost": "7TAFC018C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-wa-k-31-white.png' | asset_url }}"
  }, 
     {
    "Name": "6-vinyl-privacy-fence-w-picket-accent-afc-018-adobe",
    "Color": "Adobe",
    "Panel": "AFC018-ADOBE",
    "BlankPost": "7F10CD096081",
    "EndPost": "7DAFC018E",
    "LinePost": "7DAFC018L",
    "CornerPost": "7DAFC018C",
    "Cap": "7C55PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-wa-k-31-white.png' | asset_url }}"
  }, 
  {
    "Name": "4-vinyl-privacy-fence-afc-001-white",
    "Color": "White",
    "Panel": "AFC001-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC001E",
    "LinePost": "7WAFC001L",
    "CornerPost": "7WAFC001C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  },
   {
    "Name": "4-vinyl-privacy-fence-afc-001-tan",
    "Color": "Tan",
    "Panel": "AFC001-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC001E",
    "LinePost": "7TAFC001L",
    "CornerPost": "7TAFC001C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  },
    {
    "Name": "4-vinyl-privacy-fence-afc-001-adobe",
    "Color": "Adobe",
    "Panel": "AFC001-ADOBE",
    "BlankPost": "7F10CD096081",
    "EndPost": "7DAFC001E",
    "LinePost": "7DAFC001L",
    "CornerPost": "7DAFC001C",
    "Cap": "7C55PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  },
  //   {
  //   "Name": "4-vinyl-privacy-fence-afc-001-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "4-vinyl-privacy-fence-afc-001-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "4-vinyl-privacy-fence-afc-001-mocha-walnut",
  //   "Color": "Mocha Walnut",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "4-vinyl-privacy-fence-afc-001-green-teak",
  //   "Color": "Green Teak",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "4-vinyl-privacy-fence-afc-001-chai-gray",
  //   "Color": "Chai Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "4-vinyl-privacy-fence-afc-001-aspen-latte",
  //   "Color": "Aspen Latte",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  {
    "Name": "6-vinyl-semi-privacy-fence-afc-030-white",
    "Color": "White",
    "Panel": "AFC030-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC030E",
    "LinePost": "7WAFC030L",
    "CornerPost": "7WAFC030C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-1-white.png' | asset_url }}"
  },
  {
    "Name": "6-vinyl-semi-privacy-fence-afc-030-tan",
    "Color": "Tan",
    "Panel": "AFC030-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC030E",
    "LinePost": "7TAFC030L",
    "CornerPost": "7TAFC030C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-1-white.png' | asset_url }}"
  },
  //   {
  //   "Name": "6-vinyl-semi-privacy-fence-afc-030-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-1-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "6-vinyl-semi-privacy-fence-afc-030-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-1-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "6-vinyl-semi-privacy-fence-afc-030-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-1-white.png' | asset_url }}"
  // },
  {
    "Name": "6-vinyl-semi-private-picket-fence-afc-034-white",
    "Color": "White",
    "Panel": "AFC034-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC034E",
    "LinePost": "7WAFC034L",
    "CornerPost": "7WAFC034C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "6-vinyl-semi-private-picket-fence-afc-034-tan",
    "Color": "Tan",
    "Panel": "AFC034-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC034E",
    "LinePost": "7TAFC034L",
    "CornerPost": "7TAFC034C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "6-vinyl-semi-private-picket-fence-afc-034-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-semi-private-picket-fence-afc-034-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-semi-private-picket-fence-afc-034-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },      
  {
    "Name": "6-vinyl-alternating-picket-fence-afs-23-white",
    "Color": "White",
    "Panel": "AFS23-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFS23E",
    "LinePost": "7WAFS23L",
    "CornerPost": "7WAFS23C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "6-vinyl-alternating-picket-fence-afs-23-tan",
    "Color": "Tan",
    "Panel": "AFS23-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFS23E",
    "LinePost": "7TAFS23L",
    "CornerPost": "7TAFS23C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },  
  // {
  //   "Name": "6-vinyl-alternating-picket-fence-afs-23-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-alternating-picket-fence-afs-23-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-alternating-picket-fence-afs-23-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
 {
    "Name": "5-vinyl-semi-privacy-fence-afc-006-white",
    "Color": "White",
    "Panel": "AFC006-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC006E",
    "LinePost": "7WAFC006L",
    "CornerPost": "7WAFC006C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
 {
    "Name": "5-vinyl-semi-privacy-fence-afc-006-tan",
    "Color": "Tan",
    "Panel": "AFC006-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC006E",
    "LinePost": "7TAFC006L",
    "CornerPost": "7TAFC006C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },  
//  {
//     "Name": "5-vinyl-semi-privacy-fence-afc-006-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT558",
//     "oc" : "96",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "5-vinyl-semi-privacy-fence-afc-006-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT558",
//     "oc" : "96",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 
 {
    "Name": "4-vinyl-semi-privacy-fence-afc-0304-white",
    "Color": "White",
    "Panel": "AFC0304-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC0304E",
    "LinePost": "7WAFC0304L",
    "CornerPost": "7WAFC0304C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "4-vinyl-semi-privacy-fence-afc-0304-tan",
    "Color": "Tan",
    "Panel": "AFC0304-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC0304E",
    "LinePost": "7TAFC0304L",
    "CornerPost": "7TAFC0304C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "4-vinyl-semi-privacy-fence-afc-0304-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT558",
//     "oc" : "96",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "4-vinyl-semi-privacy-fence-afc-0304-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT558",
//     "oc" : "96",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },   
 {
    "Name": "4-vinyl-picket-fence-afc-15-white",
    "Color": "White",
    "Panel": "AFC15-WHITE",
    "BlankPost": "7F12NW072121",
    "EndPost": "7WAFC15E",
    "LinePost": "7WAFC15L",
    "CornerPost": "7WAFC15C",
    "Cap": "7C44PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "4-vinyl-picket-fence-afc-15-tan",
    "Color": "Tan",
    "Panel": "AFC15-TAN",
    "BlankPost": "7F12NT072121",
    "EndPost": "7TAFC15E",
    "LinePost": "7TAFC15L",
    "CornerPost": "7TAFC15C",
    "Cap": "7C44PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
  {
    "Name": "4-vinyl-picket-fence-afc-15-adobe",
    "Color": "Adobe",
    "Panel": "AFC15-ADOBE",
    "BlankPost": "7F12ND072121",
    "EndPost": "7DAFC15E",
    "LinePost": "7DAFC15L",
    "CornerPost": "7DAFC15C",
    "Cap": "7C44PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "4-vinyl-picket-fence-afc-15-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "4-vinyl-picket-fence-afc-15-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 

 {
    "Name": "3-vinyl-straight-routed-picket-fence-afc-11-white",
    "Color": "White",
    "Panel": "AFC11-WHITE",
    "BlankPost": "7F12NW072121",
    "EndPost": "7WAFC11E",
    "LinePost": "7WAFC11L",
    "CornerPost": "7WAFC11C",
    "Cap": "7C44PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
 {
    "Name": "3-vinyl-straight-routed-picket-fence-afc-11-tan",
    "Color": "Tan",
    "Panel": "AFC11-TAN",
    "BlankPost": "7F12NT072121",
    "EndPost": "7TAFC11E",
    "LinePost": "7TAFC11L",
    "CornerPost": "7TAFC11C",
    "Cap": "7C44PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "3-vinyl-straight-routed-picket-fence-afc-11-adobe",
    "Color": "Adobe",
    "Panel": "AFC11-ADOBE",
    "BlankPost": "7F12ND072121",
    "EndPost": "7DAFC11E",
    "LinePost": "7DAFC11L",
    "CornerPost": "7DAFC11C",
    "Cap": "7C44PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "3-vinyl-straight-routed-picket-fence-afc-11-white-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "3-vinyl-straight-routed-picket-fence-afc-11-white-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 

  {
    "Name": "6-vinyl-pool-picket-fence-afc-017-white",
    "Color": "White",
    "Panel": "AFC017-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC017E",
    "LinePost": "7WAFC017L",
    "CornerPost": "7WAFC017C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "6-vinyl-pool-picket-fence-afc-017-tan",
    "Color": "Tan",
    "Panel": "AFC017-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC017E",
    "LinePost": "7TAFC017L",
    "CornerPost": "7TAFC017C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "6-vinyl-pool-picket-fence-afc-017-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
    // {
  //   "Name": "6-vinyl-pool-picket-fence-afc-017-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-pool-picket-fence-afc-017-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },

  {
    "Name": "5-vinyl-closed-picket-fence-afc-014-white",
    "Color": "White",
    "Panel": "AFC014-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC014E",
    "LinePost": "7WAFC014L",
    "CornerPost": "7WAFC014C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "5-vinyl-closed-picket-fence-afc-014-tan",
    "Color": "Tan",
    "Panel": "AFC014-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC014E",
    "LinePost": "7TAFC014L",
    "CornerPost": "7TAFC014C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "5-vinyl-closed-picket-fence-afc-014-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
    // {
  //   "Name": "5-vinyl-closed-picket-fence-afc-014-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "5-vinyl-closed-picket-fence-afc-014-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },

  {
    "Name": "4-vinyl-closed-picket-fence-afc-17-white",
    "Color": "White",
    "Panel": "AFC17-WHITE",
    "BlankPost": "7F12NW072121",
    "EndPost": "7WAFC17E",
    "LinePost": "7WAFC17L",
    "CornerPost": "7WAFC17C",
    "Cap": "7C44PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
 {
    "Name": "4-vinyl-closed-picket-fence-afc-17-tan",
    "Color": "Tan",
    "Panel": "AFC17-TAN",
    "BlankPost": "7F12NT072121",
    "EndPost": "7TAFC17E",
    "LinePost": "7TAFC17L",
    "CornerPost": "7TAFC17C",
    "Cap": "7C44PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "4-vinyl-closed-picket-fence-afc-17-adobe",
    "Color": "Adobe",
    "Panel": "AFC17-ADOBE",
    "BlankPost": "7F12ND072121",
    "EndPost": "7DAFC17E",
    "LinePost": "7DAFC17L",
    "CornerPost": "7DAFC17C",
    "Cap": "7C44PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "4-vinyl-closed-picket-fence-afc-17-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "4-vinyl-closed-picket-fence-afc-17-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 

  {
    "Name": "3-vinyl-closed-picket-fence-afc-16-white",
    "Color": "White",
    "Panel": "AFC16-WHITE",
    "BlankPost": "7F12NW072121",
    "EndPost": "7WAFC16E",
    "LinePost": "7WAFC16L",
    "CornerPost": "7WAFC16C",
    "Cap": "7C44PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
 {
    "Name": "3-vinyl-closed-picket-fence-afc-16-tan",
    "Color": "Tan",
    "Panel": "AFC16-TAN",
    "BlankPost": "7F12NT072121",
    "EndPost": "7TAFC16E",
    "LinePost": "7TAFC16L",
    "CornerPost": "7TAFC16C",
    "Cap": "7C44PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "3-vinyl-closed-picket-fence-afc-16-adobe",
    "Color": "Adobe",
    "Panel": "AFC16-ADOBE",
    "BlankPost": "7F12ND072121",
    "EndPost": "7DAFC16E",
    "LinePost": "7DAFC16L",
    "CornerPost": "7DAFC16C",
    "Cap": "7C44PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "3-vinyl-closed-picket-fence-afc-16-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "3-vinyl-closed-picket-fence-afc-16-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 

  {
    "Name": "6-vinyl-overscallop-picket-afc-012-white",
    "Color": "White",
    "Panel": "AFC012-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC012E",
    "LinePost": "7WAFC012L",
    "CornerPost": "7WAFC012C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
  {
    "Name": "6-vinyl-overscallop-picket-afc-012-tan",
    "Color": "Tan",
    "Panel": "AFC012-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC012E",
    "LinePost": "7TAFC012L",
    "CornerPost": "7TAFC012C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "6-vinyl-overscallop-picket-afc-012-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
    // {
  //   "Name": "6-vinyl-overscallop-picket-afc-012-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-overscallop-picket-afc-012-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },

  {
    "Name": "5-vinyl-overscallop-picket-fence-afc-004-white",
    "Color": "White",
    "Panel": "AFC004-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC004E",
    "LinePost": "7WAFC004L",
    "CornerPost": "7WAFC004C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
    {
    "Name": "5-vinyl-overscallop-picket-fence-afc-004-tan",
    "Color": "Tan",
    "Panel": "AFC004-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC004E",
    "LinePost": "7TAFC004L",
    "CornerPost": "7TAFC004C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "5-vinyl-overscallop-picket-fence-afc-004-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
    // {
  //   "Name": "5-vinyl-overscallop-picket-fence-afc-004-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "5-vinyl-overscallop-picket-fence-afc-004-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },

  {
    "Name": "4-vinyl-overscallop-picket-fence-afc-016-white",
    "Color": "White",
    "Panel": "AFC016-WHITE",
    "BlankPost": "7F12NW072121",
    "EndPost": "7WAFC016E",
    "LinePost": "7WAFC016L",
    "CornerPost": "7WAFC016C",
    "Cap": "7C44PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
 {
    "Name": "4-vinyl-overscallop-picket-fence-afc-016-tan",
    "Color": "Tan",
    "Panel": "AFC016-TAN",
    "BlankPost": "7F12NT072121",
    "EndPost": "7TAFC016E",
    "LinePost": "7TAFC016L",
    "CornerPost": "7TAFC016C",
    "Cap": "7C44PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "4-vinyl-overscallop-picket-fence-afc-016-adobe",
    "Color": "Adobe",
    "Panel": "AFC016-ADOBE",
    "BlankPost": "7F12ND072121",
    "EndPost": "7DAFC016E",
    "LinePost": "7DAFC016L",
    "CornerPost": "7DAFC016C",
    "Cap": "7C44PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "4-vinyl-overscallop-picket-fence-afc-016-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "4-vinyl-overscallop-picket-fence-afc-016-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 

  {
    "Name": "6-vinyl-underscallop-picket-fence-afc-013-white",
    "Color": "White",
    "Panel": "AFC013-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC013E",
    "LinePost": "7WAFC013L",
    "CornerPost": "7WAFC013C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
  {
    "Name": "6-vinyl-underscallop-picket-fence-afc-013-tan",
    "Color": "Tan",
    "Panel": "AFC013-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC013E",
    "LinePost": "7TAFC013L",
    "CornerPost": "7TAFC013C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "6-vinyl-underscallop-picket-fence-afc-013-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
    // {
  //   "Name": "6-vinyl-underscallop-picket-fence-afc-013-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "6-vinyl-underscallop-picket-fence-afc-013-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },

  {
    "Name": "5-vinyl-underscallop-picket-fence-afc-003-white",
    "Color": "White",
    "Panel": "AFC003-WHITE",
    "BlankPost": "7F10CW096081",
    "EndPost": "7WAFC003E",
    "LinePost": "7WAFC003L",
    "CornerPost": "7WAFC003C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
    {
    "Name": "5-vinyl-underscallop-picket-fence-afc-003-tan",
    "Color": "Tan",
    "Panel": "AFC003-TAN",
    "BlankPost": "7F10CT096081",
    "EndPost": "7TAFC003E",
    "LinePost": "7TAFC003L",
    "CornerPost": "7TAFC003C",
    "Cap": "7C55PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "96",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  // {
  //   "Name": "5-vinyl-underscallop-picket-fence-afc-003-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // }, 
    // {
  //   "Name": "5-vinyl-underscallop-picket-fence-afc-003-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },
  // {
  //   "Name": "5-vinyl-underscallop-picket-fence-afc-003-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "96",
  //   "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  // },

  {
    "Name": "4-vinyl-underscallop-picket-fence-afc-97-white",
    "Color": "White",
    "Panel": "AFC97-WHITE",
    "BlankPost": "7F12NW072121",
    "EndPost": "7WAFC97E",
    "LinePost": "7WAFC97L",
    "CornerPost": "7WAFC97C",
    "Cap": "7C44PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
 {
    "Name": "4-vinyl-underscallop-picket-fence-afc-97-tan",
    "Color": "Tan",
    "Panel": "AFC97-TAN",
    "BlankPost": "7F12NT072121",
    "EndPost": "7TAFC97E",
    "LinePost": "7TAFC97L",
    "CornerPost": "7TAFC97C",
    "Cap": "7C44PYRAT",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  },
  {
    "Name": "4-vinyl-underscallop-picket-fence-afc-97-adobe",
    "Color": "Adobe",
    "Panel": "AFC97-ADOBE",
    "BlankPost": "7F12ND072121",
    "EndPost": "7DAFC97E",
    "LinePost": "7DAFC97L",
    "CornerPost": "7DAFC97C",
    "Cap": "7C44PYRAD",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT446",
    "oc" : "73",
    "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
  }, 
//  {
//     "Name": "4-vinyl-underscallop-picket-fence-afc-97-light-gray",
//     "Color": "Light Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   },
//   {
//     "Name": "4-vinyl-underscallop-picket-fence-afc-97-dark-gray",
//     "Color": "Dark Gray",
//     "Panel": "",
//     "BlankPost": "",
//     "EndPost": "",
//     "LinePost": "",
//     "CornerPost": "",
//     "Cap": "",
//     "Hinge": "7FBFGZ300221",
//     "Latch": "7FBFGZ300321",
//     "DropRod": "7FBFGZ300121",
//     "Glue": "7RHFW15",
//     "GatePostInsert": "7INSERT446",
//     "oc" : "73",
//     "ImageUrl": "{{'Vinyl-semi_Priv-6-white.png' | asset_url }}"
//   }, 

    {
    "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-white",
    "Color": "White",
    "Panel": "AFC19A-WHITE",
    "BlankPost": "7F10CW096081",  
    "EndPost": "7WAFC19AE",
    "LinePost": "7F10JW078081",
    "CornerPost": "7WAFC19AC",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "97",
    "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-tan",
  //   "Color": "Tan",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-mocha-walnut",
  //   "Color": "Mocha Walnut",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-green-teak",
  //   "Color": "Green Teak",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-chai-gray",
  //   "Color": "Chai Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "5-vinyl-3-rail-ranch-rail-fence-afc-19a-aspen-latte",
  //   "Color": "Aspen Latte",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },

  {
    "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-white",
    "Color": "White",
    "Panel": "AFC302-WHITE",
    "BlankPost": "7F10CW096081",  
    "EndPost": "7WAFC302E",
    "LinePost": "7F10JW060081",
    "CornerPost": "7WAFC302C",
    "Cap": "7C55PYRAW",
    "Hinge": "7FBFGZ300221",
    "Latch": "7FBFGZ300321",
    "DropRod": "7FBFGZ300121",
    "Glue": "7RHFW15",
    "GatePostInsert": "7INSERT558",
    "oc" : "97",
    "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  },   
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-tan",
  //   "Color": "Tan",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-adobe",
  //   "Color": "Adobe",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-light-gray",
  //   "Color": "Light Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-dark-gray",
  //   "Color": "Dark Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-mocha-walnut",
  //   "Color": "Mocha Walnut",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-green-teak",
  //   "Color": "Green Teak",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-chai-gray",
  //   "Color": "Chai Gray",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },
  //   {
  //   "Name": "3-vinyl-2-rail-ranch-rail-fence-afc-302-aspen-latte",
  //   "Color": "Aspen Latte",
  //   "Panel": "",
  //   "BlankPost": "",  
  //   "EndPost": "",
  //   "LinePost": "",
  //   "CornerPost": "",
  //   "Cap": "",
  //   "Hinge": "7FBFGZ300221",
  //   "Latch": "7FBFGZ300321",
  //   "DropRod": "7FBFGZ300121",
  //   "Glue": "7RHFW15",
  //   "GatePostInsert": "7INSERT558",
  //   "oc" : "97",
  //   "ImageUrl": "{{'Vinyl-Priv-4-white.png' | asset_url }}"
  // },  

  // *** Wood Fence Parts List ***
  
  
  {
    "Name": "6-solid-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'Wood-Solid-6.png' | asset_url }}"
  },
  {
    "Name": "6-solid-wood-with-custom-4-pickets",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'6-Picket-Wood-with-4-Pickets.png' | asset_url }}"
  },
  {
    "Name": "6-shadow-box-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'Wood-shadow-box-6.png' | asset_url }}"
  },
  {
    "Name": "6-shadow-box-wood-with-custom-4-pickets",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'Wood-shadow-box-6-4-picket.png' | asset_url }}"
  },
  {
    "Name": "6-french-gothic-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'Wood-french-Gothic.png' | asset_url }}"
  },
  {
    "Name": "6-picket-wood-with-4-pickets",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'Wood-Solid-6-w-4.png' | asset_url }}"
  },
  {
    "Name": "6-alternating-picket-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3"
  },
  {
    "Name": "6-picket-wood-w-1-gap",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'6PicketWoodw1gap.png' | asset_url }}"
  },
  {
    "Name": "6-shadow-box-scalloped-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'6-Shadow-Box-Scalloped-Wood.png' | asset_url }}"
  },
  {
    "Name": "6-solid-scalloped-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'6-Solid-Scalloped-Wood.png' | asset_url }}"
  },
  {
    "Name": "6-picket-scalloped-wood",
    "Color": "Cedar",
    "Post": "63380",
    "Rail": "62483",
    "Picket": "61563",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "3",
    "ImageUrl": "{{'6-Picket-Scalloped-Wood.png' | asset_url }}"
  },
  {
    "Name": "4-solid-wood",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61641",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'Wood-Solid-4.png' | asset_url }}"
  },
  {
    "Name": "4-shadow-box-wood-with-4-pickets",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61441",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'Wood-shadow-box-4-4-picket-.png | asset_url }}"
  },
  {
    "Name": "4-shadow-box-wood-with-6-pickets",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61641",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'Wood-shadow-box-4-6-picket.png' | asset_url }}"
  },
  {
    "Name": "4-french-gothic-wood",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61441",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'4-French-Gothic-Wood.png' | asset_url }}"
  },
  {
    "Name": "4-picket-wood-fence",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61441",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'4-Picket-Wood-Fence.png' | asset_url }}"
  },
  {
    "Name": "4-picket-wood-w-capboard",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61441",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'4-Picket-Wood-wCapboard.png' | asset_url }}"
  },
  {
    "Name": "4-shadow-box-scalloped-wood",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61641",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'4-Shadow-Box-Scalloped-Wood.png' | asset_url }}"
  },
  {
    "Name": "4-solid-scalloped-wood",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61641",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'4-Solid-Scalloped-Wood.png' | asset_url }}"
  },
  {
    "Name": "4-picket-scalloped-wood",
    "Color": "Cedar",
    "Post": "63360",
    "Rail": "62483",
    "Picket": "61441",
    "Latch": "10906",
    "Hinge": "10910",
    "DropRod":"10918",
    "Additional": "2",
    "ImageUrl": "{{'4-Picket-Scalloped-Wood.png' | asset_url }}"
  }
] 
